// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__3xcRm","xs":"TextInput_xs__MEWPQ","sm":"TextInput_sm__u8wuj","md":"TextInput_md__wKB-I","lg":"TextInput_lg__1az3d","xl":"TextInput_xl__GYCq2"};